<router-outlet></router-outlet>
<calsoft-tour-overlay></calsoft-tour-overlay>
<calsoft-step-guide></calsoft-step-guide>
<calsoft-loader></calsoft-loader>

<!-- Global Recording Pill (persists across navigation) -->
<!-- <div class="global-recording-pill" *ngIf="guideService.isRecording$ | async">
    <span class="rec-dot"></span>
    <span class="rec-label">
        <ng-container *ngIf="!(guideService.pendingActionStep$ | async)">Recording...</ng-container>
        <ng-container *ngIf="guideService.pendingActionStep$ | async">Element captured</ng-container>
    </span>
    <button class="rec-stop-btn" (click)="stopRecordingAndReturn()">
        <svg width="12" height="12" viewBox="0 0 12 12" fill="currentColor">
            <rect x="1" y="1" width="10" height="10" rx="1" />
        </svg>
        Stop
    </button>
</div> -->

<!-- Action Chooser Card (shown when an element is captured and awaiting confirmation) -->
<div class="rec-action-chooser" *ngIf="guideService.pendingActionStep$ | async as pending"
    (click)="$event.stopPropagation()" (mousedown)="$event.stopPropagation()">
    <div class="rec-action-header">
        <span class="rec-action-title">What should this step do?</span>
        <button class="rec-action-close" (click)="$event.stopPropagation(); discardCapture()"
            title="Discard">&#x2715;</button>
    </div>
    <div class="rec-action-info" *ngIf="pending.guideId || pending.selector">
        <span class="rec-action-info-label">Element:</span>
        <span class="rec-action-info-value">{{ pending.guideId || pending.selector }}</span>
    </div>
    <div class="rec-action-buttons">
        <button class="rec-action-btn rec-action-click" (click)="$event.stopPropagation(); confirmAction('click')">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M9 9l-4 12 7-4 4 7 4-16-11 1z" />
            </svg>
            Click
            <span class="rec-action-hint">Auto-clicks during playback</span>
        </button>
        <button class="rec-action-btn rec-action-none" (click)="$event.stopPropagation(); confirmAction('none')">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <circle cx="12" cy="12" r="10" />
                <line x1="12" y1="8" x2="12" y2="12" />
                <line x1="12" y1="16" x2="12.01" y2="16" />
            </svg>
            None
            <span class="rec-action-hint">Record step, no auto-click</span>
        </button>
    </div>
</div>